export default __webpack_public_path__ + "static/media/MayoLovelace.db441d0a.png";